import styled from 'styled-components';

export const CustomerFieldsAccordionContainer = styled.div`
    border-bottom: ${({ theme }) => `1px solid ${theme.dashboardDrActivityDashboardHrDividerBorderBottom}`};
    padding-top: 1.143rem;
    padding-bottom: 1.143rem;

    &.additional-income-section {
        border-bottom: none;
    }
`;

export const CustomerFieldsContainer = styled.div<{ expanded?: boolean }>`
    padding-top: 1.143rem;
`;

export const ExpandedSectionCard = styled.div`
    background-color: #f4f4f4;
    padding: 1.143rem;
`;

export const LayoutHeaderRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1.143rem;
`;

export const EmployerAddressFieldWrapper = styled.div`
    grid-column: span 2;
`;
